// src/hooks/currencies/useCreateCurrencies.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createCurrency } from "../../api/apiCurrencies";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateCurrencies = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {
        mutate: createCurrencies,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createCurrency,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/currencies');
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create currency");
        },
    });

    return {
        createCurrencies,
        isPending: isPending || isLoading,
    };
};

export default useCreateCurrencies;
